export default __webpack_public_path__ + "static/media/hero-image-3.50a3b98a.png";